
import React from 'react';
import { HashRouter  as Router, Route} from "react-router-dom";

import Home from './components/Home'
import Business from './components/business'
import Zp from './components/zp'
import About from './components/about'
import Lx from './components/lx'
function MainRouter(){



    return (
        <Router>      
            {/* <Route exact  path="/"  component={Login} /> */}
            <Route exact  path='/' component={Home} />
            <Route exact  path='/business' component={Business} />
            <Route exact  path='/zp' component={Zp} />
            <Route exact  path='/about' component={About} />
            <Route exact  path='/lx' component={Lx} />
        </Router>
    )
}
export default MainRouter